if (!customElements.get('featured-card-slider')) {
  class FeaturedCardSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.advance-featured-card-slider-viewport');
      this.track = this.querySelector('.advance-featured-card-slider-track');
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.querySelectorAll('[data-scroll-target]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          const targetClass = btn.getAttribute('data-scroll-target');
          if (!targetClass) return;
          event.preventDefault();
          const target = document.querySelector('.' + CSS.escape(targetClass));
          if (target) {
            target.scrollIntoView({
              behavior: this.prefersReducedMotion.matches ? 'auto' : 'smooth',
              block: 'start',
            });
          }
        });
      });

      this.adjustViewport = this.adjustViewport.bind(this);
      this.onResize = this.onResize.bind(this);
      this.adjustViewport();
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      clearTimeout(this.resizeTimer);
    }

    onResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(this.adjustViewport, 150);
    }

    adjustViewport() {
      if (!this.viewport || !this.track) return;
      const cards = this.track.querySelectorAll('.advance-featured-card-slider-card');
      const isDesktop = window.innerWidth >= 769;
      const fitsWithoutScroll = isDesktop && cards.length <= 4;
      this.viewport.classList.toggle('advance-featured-card-slider-hide-scrollbar', fitsWithoutScroll);
      this.track.classList.toggle('advance-featured-card-slider-center-cards', fitsWithoutScroll);
    }
  }

  customElements.define('featured-card-slider', FeaturedCardSlider);
}
